import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';

import { AppLanguage } from './models';
import { LanguageService, SetLanguage } from '@ca/ca-ng-core';
import { Router } from '@angular/router';

export function appInitializer() {
  return () => {
    const store = inject(Store);
    const cookieService = inject(CookieService);
    const languageService = inject(LanguageService);
    const router = inject(Router);

    const availableLanguages = ['en', 'nl', 'fr'];
    const defaultLanguage = 'en';

    // Get the current path segments
    const currentUrl = window.location.pathname;
    const urlSegments = currentUrl.split('/').filter(Boolean); // Remove empty segments
    let lang = urlSegments[0]; // First segment should be the language
    // Check if URL contains a valid language
    if (!availableLanguages.includes(lang)) {
      console.warn('Invalid or missing language in URL, determining fallback language...');

      // Try to get language from cookie
      lang = cookieService.get('user_language') || '';

      // If no cookie, detect from browser
      if (!lang || !availableLanguages.includes(lang)) {
        lang = languageService.detectLanguage(availableLanguages);
      }

      // If still no valid language, use default
      if (!lang || !availableLanguages.includes(lang)) {
        lang = defaultLanguage;
      }

      // Store detected language in cookie (7-day expiry)
      cookieService.set('user_language', lang, 7, '/');

      // Redirect **only if needed**
      if (urlSegments.length === 0 || !availableLanguages.includes(urlSegments[0])) {
        // console.log(`Redirecting to: /${lang}`);

        // Store language in cookie if it's valid
        cookieService.set('user_language', lang, 7, '/');

        // console.log('Setting active language:', lang);
        const language = lang as AppLanguage;
        store.dispatch(SetLanguage({ language, init: true }));
        router.navigate([`/${lang}`], { replaceUrl: true });
        return;
      }
    }

    // Store language in cookie if it's valid
    cookieService.set('user_language', lang, 7, '/');

    // console.log('Setting active language:', lang);
    const language = lang as AppLanguage;
    store.dispatch(SetLanguage({ language, init: true }));
  };
}
